import React from 'react'
import { ContextNotification } from '@pandiafi/components'
import { useTranslation } from 'react-i18next'

import type {
  CoreParkingArea,
  CoreParkingSpot,
} from '../../../common/validations/contractParkingSpotsSchema'
import { spotTitle, spotEquipmentLabel, areaAddressLabel } from './uiSelectors'
import { ParkingSpotPrice } from './ParkingSpotPrice'

export interface ParkingSpotSuccessProps {
  spot: CoreParkingSpot
  area: CoreParkingArea
  fromISO: string
  isComplimentary?: boolean
}

export const ParkingSpotSuccess: React.FC<ParkingSpotSuccessProps> = ({
  spot,
  area,
  fromISO,
  isComplimentary = false,
}) => {
  const { t, i18n } = useTranslation('parking')

  const formatDate = (iso: string) =>
    new Date(iso).toLocaleDateString(i18n.language)

  const title = spotTitle(spot)
  const addressLabel = areaAddressLabel(area)
  const equipmentText = spotEquipmentLabel(spot, t)

  return (
    <ContextNotification type="success">
      <div>
        <h4 className="text-xl font-semibold mb-4">{t('success.title')}</h4>
        <div className="font-semibold">
          {title}
          {addressLabel && (
            <>
              , {t('address.at')}
              <br />
              <strong>{addressLabel}</strong>
            </>
          )}{' '}
          {t('success.starts')} <strong>{formatDate(fromISO)}</strong>.
        </div>
        <ParkingSpotPrice
          spot={spot}
          atISO={fromISO}
          isComplimentary={isComplimentary}
          className="mt-4 font-bold"
        />
        {equipmentText && (
          <div className="mt-4">
            {t('spot.equipment')}: {equipmentText}
          </div>
        )}
      </div>
    </ContextNotification>
  )
}
